import axios from 'axios';

export default () => axios.get(`${process.env.VUE_APP_API_ENDPOINT}/lenders`);
